import { convertReactAdminIdToHydraId } from 'utils/convertReactAdminIdToHydraId';

export const enum Directions {
  Payment = 'payment',
  Payout = 'payout',
}

export const PAYMENT_DIRECTION_ID = convertReactAdminIdToHydraId(Directions.Payment, 'directions');
export const PAYOUT_DIRECTION_ID = convertReactAdminIdToHydraId(Directions.Payout, 'directions');
